<template>
    <div :style="'--textcolor: ' + color_1 + ';--bgcolor:' + color_2 + ';--sitecolor: ' + color_3 + ';--altcolor: ' + color_4 + ';--alttextcolor: ' + color_5 + ';'">
        <template v-if="configuracion">
            <LoadCssComponent :estilos="configuracion.css_front"/>
        </template>

        <transition name="fade" mode="out-in" v-if="!loading && !loading_user">
            <router-view/>
        </transition>

        <transition name="fade" mode="out-in" v-if="loading">
            <PreLoaderComponent/>
        </transition>
        
        <Localize v-if="!loading"/>
    </div>
</template>

<script>
    import PreLoaderComponent from '@/components/preloader/PreLoaderComponent';
    import LoadCssComponent from  '@/components/css/LoadCssComponent';
    import Localize from "@/components/common/Localize";

    export default {
        name: 'App',
        data() {
            return {
                loading: true,
                loading_user: true
            }
        },
        created() {
            this.debouncedStopLoader = _.debounce(this.stopLoader, 1000);
            this.setFavicon()

            if(this.$route.query.track) {
                this.$cookies.set('comunicados-track-id', this.$route.query.track)
            }
        },
        computed: {
            logo() {
                return this.manager ? this.manager.logo : 'https://www.compralaentrada.com/favicon.ico';
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            manager() {
                return this.$store.getters.getFooter;
            },
            color_1() {
                return this.manager ? this.manager.textcolor : '';
            },
            color_2() {
                return this.manager ? this.manager.bgcolor : '';
            },
            color_3() {
                return this.manager ? this.manager.sitecolor : '';
            },
            color_4() {
                return this.manager ? this.manager.altcolor : '';
            },
            color_5() {
                return this.manager ? this.manager.alttextcolor : '';
            },
            favicon() {
                if(this.manager) {
                    return this.manager.logo;
                } else {
                    return this.dynamicConfig.url_icon;
                }
            },
            dynamicConfig() {
                return this.$store.getters.getDynamicConfig;
            }
        },
        mounted() {
            this.getConfig();
        },
        watch: {
            configuracion() {
                document.title = this.configuracion.title;
            },
            favicon() {
                this.setFavicon();
            }
        },
        methods: {
            setFavicon() {
                const favicons = document.querySelectorAll('[rel="icon"]');
                for(var index in favicons) {
                    if(favicons[index] != 2 && favicons[index] != 1) {
                        favicons[index].href = this.favicon;
                    }
                }
            },
            checkUser() {
                if(!localStorage.getItem("token") || localStorage.getItem("token") == null || localStorage.getItem("token") == 'null') {
                    this.loading_user = false;
                    return;                
                }

                const data = {
                    filters: {
                        tid : this.configuracion.hash_teatro
                    }
                };

                this.$store.dispatch(this.config.getVuexAlias('check'), data).finally(res => {
                    this.$nextTick(() => {
                        this.loading_user = false;
                    });

                    var user = this.$store.getters.getUser;

                    if (window.location.href.includes('admin')) {
                        if (user === null) {
                            this.$router.push('/');
                        }
                    }

                    if (window.location.href.includes('admin')) {
                        if (user && user.tipo === 'user') {
                            this.$router.push('/');
                        }
                    }
                });
            },
            getConfig : function() {
                this.setLista();
                this.setTeatro();

                const data = {
                    nombre: this.$route.query.base ? this.$route.query.base : this.dynamicConfig.base,
                }

                this.$store.dispatch(this.config.getVuexAlias('config'), data).then(res => {
                    if(! res.data.mantenimiento) {
                        this.checkUser();
                        this.getEventos();
                        this.getExperiencias();
                        this.getFooter();
                    } else {
                        this.setMantenimiento()
                    }

                });
            },
            stopLoader() {
                this.loading = false
            },
            setLista() {
                if(localStorage.getItem('lista_id') != null) {
                    this.$store.commit('setListaId', localStorage.getItem('lista_id'));
                }
            },
            setTeatro() {
                if(localStorage.getItem('teatro_id') != null) {
                    this.$store.commit('setTeatroId', localStorage.getItem('teatro_id'));
                }
            },
            getEventos : function() {
                const params = {
                    filters : {
                        tid : this.configuracion.hash_teatro
                    }
                }

                this.$store.dispatch(this.config.getVuexAlias('front.events.index'), params).then(res => {
                    this.debouncedStopLoader();
                }).catch(error => {
                    this.loading = false;
                    this.$router.push({name: "front.error", params: {error: "getEventos"}});
                    console.log(error);
                });
            },
            getExperiencias : function() {
                const params = {
                    filters : {
                        tid : this.configuracion.hash_teatro,
                        experiencias: 1
                    }
                }

                this.$store.dispatch(this.config.getVuexAlias('front.experiencias.index'), params).then(res => {
                    this.debouncedStopLoader();
                }).catch(error => {
                    this.loading = false;
                    this.$router.push({name: "front.error", params: {error: "getEventos"}});
                    console.log(error);
                });
            },
            getFooter() {
                const params = {
                    filters : {
                        tid : this.configuracion.hash_teatro
                    }
                }

                this.$store.dispatch(this.config.getVuexAlias('settings'), params).then(res => {
                    this.debouncedStopLoader();
                });
            },
            setMantenimiento() {
                this.loading = false;
                this.$router.push({ name: "front.mantenimiento" });
            }
        },
        components: {
            PreLoaderComponent, LoadCssComponent, Localize
        }
    }
</script>
